module.exports = __webpack_public_path__ + "img/logoTA.472bc729.svg";